"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavItems = exports.NavItem = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const NavItem_1 = require("@reactionable/core/lib/nav/NavItem");
const NavLink_1 = tslib_1.__importDefault(require("react-bootstrap/NavLink"));
const Icon_1 = require("../icon/Icon");
const Link_1 = require("../link/Link");
function NavItem(_a) {
    var { icon, children } = _a, linkProps = tslib_1.__rest(_a, ["icon", "children"]);
    if (!linkProps.title && typeof children === "string") {
        const title = children;
        linkProps.title = title;
    }
    if (icon) {
        children = (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx(Icon_1.Icon, Object.assign({}, icon), void 0), " ", children] }, void 0));
    }
    return (jsx_runtime_1.jsx(NavLink_1.default, Object.assign({}, linkProps, { as: Link_1.Link }, { children: children }), void 0));
}
exports.NavItem = NavItem;
function NavItems(props) {
    return jsx_runtime_1.jsx(NavItem_1.NavItems, Object.assign({ Component: NavItem }, props), void 0);
}
exports.NavItems = NavItems;
//# sourceMappingURL=NavItem.js.map